<div
  class="card--summary__livestream__overlay"
  tabindex="0"
  role="button"
  [attr.aria-label]="'play.button' | translate"
  (click)="startStream()"
  *ngIf="!iframeUrl && !started"
>
  <span aria-hidden="true" [inlineSVG]="'/assets/icons/play.svg'"></span>
</div>
<div class="live-stream" #holder>
  <div class="live-stream__error" [hidden]="!showError">
    {{ 'live-stream.not_available' | translate }}
  </div>
  <video
    class="live-stream__video"
    #video
    playsinline
    muted
    autoplay
    *ngIf="!iframeUrl"
  ></video>
  <iframe
    *ngIf="iframeUrl"
    [src]="iframeUrl"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>
</div>
